document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.product-tabs__tab-link');
  const contents = document.querySelectorAll('.product-tabs__tab-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      const target = tab.getAttribute('data-tab');
      const targetContent = document.getElementById(target);

      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));

      // Add active class to clicked tab
      tab.classList.add('active');

      // Show target content
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
}); 